import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { releaseStuckModalOverlays } from '@/lib/modalOverlayCleanup'

/**
 * Scroll to top on route changes so marketing/footer links don't land mid-page.
 * Hash links still scroll to the matching element when present.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    if (typeof window === 'undefined') return
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return
    releaseStuckModalOverlays()

    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ''))
      if (id) {
        // Wait a tick for the destination page to render.
        requestAnimationFrame(() => {
          const el = document.getElementById(id)
          if (el) {
            el.scrollIntoView()
            return
          }
          window.scrollTo(0, 0)
        })
        return
      }
    }

    window.scrollTo(0, 0)
  }, [pathname, search, hash])

  return null
}
